export default {
    APPROVE_LAYERS: 'APPROVE_LAYERS',
    APPROVE_MEDIA: 'APPROVE_MEDIA',
    CONTENT_PUSH: 'CONTENT_PUSH',
    DEVICE_ADD: 'DEVICE_ADD',
    DEVICE_DELETE: 'DEVICE_DELETE',
    DEVICE_REBOOT: 'DEVICE_REBOOT',
    DEVICE_SETTINGS_EDIT: 'DEVICE_SETTINGS_EDIT',
    DEVICE_SETTINGS_PUSH: 'DEVICE_SETTINGS_PUSH',
    DOWNLOAD_BLOCKED: 'DOWNLOAD_BLOCKED',
    STORE_ADD: 'STORE_ADD',
    STORE_EDIT: 'STORE_EDIT',
    STORE_NOTE_EDIT: 'STORE_NOTE_EDIT',
    STORE_NOTE_VIEW: 'STORE_NOTE_VIEW',
    VIEW_ADCREATE: 'VIEW_ADCREATE',
    VIEW_CONFIGURE: 'VIEW_CONFIGURE',
    VIEW_CONTENT: 'VIEW_CONTENT',
    VIEW_ESTATE_LIST: 'VIEW_ESTATE_LIST',
    VIEW_ESTATE_MAP: 'VIEW_ESTATE_MAP',
    VIEW_HIDDEN_ESTATES: 'VIEW_HIDDEN_ESTATES',
    VIEW_LOGS: 'VIEW_LOGS',
    VIEW_MEDIA: 'VIEW_MEDIA',
    VIEW_REPORTS: 'VIEW_REPORTS',
    VIEW_LAYERS: 'VIEW_LAYERS',
    VIEW_SELF_SERVE: 'VIEW_SELF_SERVE',
}
